import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { IFormStepper, IViewUserprops, IViewUserState } from './interface';
import { ShowBlocker } from '../../../Components/LoaderComponent/LoaderComponent';
import { Stepper, Step, StepLabel, Box, StepConnector, styled } from '@mui/material';
import { IFormDetails } from "../../Form8821/interface";


import './ViewUser.css';
import { IUserDetails } from '../interface';
import Swal from 'sweetalert2';
import FormServices from '../../../Services/FormServices';
import { loadFromLocalStorage } from '../../../Common/Validation/LocalStorage';




const steps = ['Form Submitted', 'DocuSign Completed', 'Submitted to IRS', 'Approved by IRS'];



class ViewUser extends React.Component<IViewUserprops, IViewUserState> {


    constructor(props_: any) {
        super(props_);
        this.state = {
            accessToken: '',
            userId: this.props.userId,
            form433A: this.props.form433A,
            form8821: this.props.form8821,
            form433D: this.props.form433D,
            formStepper: {
                formCompleted: this.props.form8821.envelopeId ? true : false,
                docusignCompleted: this.props.form8821.isSignatureCompleted,
                submittedToIrs: this.props.form8821.isSubmittedToIRS,
                isIrsApproved: this.props.form8821.isApproved,
                envelopeId: this.props.form8821.envelopeId,
                isEligibleToReSubmit: this.props.form8821.isEligibleToResubmit,
                isIrsRejected: this.props.form8821.isRejected
            },
            jointFormStepper: {
                formCompleted: this.props.form8821.nonTaxpayer &&  this.props.form8821.nonTaxpayer.envelopeId ? true : false ,
                docusignCompleted: this.props.form8821.nonTaxpayer && this.props.form8821.nonTaxpayer.isSignatureCompleted,
                submittedToIrs: this.props.form8821.nonTaxpayer &&  this.props.form8821.nonTaxpayer.isSubmittedToIRS,
                isIrsApproved: this.props.form8821.nonTaxpayer &&  this.props.form8821.nonTaxpayer.isApproved,
                envelopeId: this.props.form8821.nonTaxpayer &&  this.props.form8821.nonTaxpayer.envelopeId,
                isEligibleToReSubmit: this.props.form8821.nonTaxpayer &&  this.props.form8821.nonTaxpayer.isEligibleToResubmit,
                isIrsRejected: this.props.form8821.nonTaxpayer &&  this.props.form8821.nonTaxpayer.isRejected
            },
            form433AStepper: {
                formCompleted: this.props.form433A.envelopeId ? true : false,
                docusignCompleted: this.props.form433A.isSignatureCompleted,
                submittedToIrs: this.props.form433A.isSubmittedToIRS,
                isIrsApproved: this.props.form433A.isApproved,
                envelopeId: this.props.form433A.envelopeId ? this.props.form433A.envelopeId : '',
                isEligibleToReSubmit: this.props.form433A.isEligibleToResubmit,
                isIrsRejected: this.props.form433A.isRejected
            },
            jointForm433AStepper: {
                formCompleted: this.props.form433A.nonTaxpayer &&  this.props.form433A.nonTaxpayer.envelopeId ? true : false ,
                docusignCompleted: this.props.form433A.nonTaxpayer && this.props.form433A.nonTaxpayer.isSignatureCompleted,
                submittedToIrs: this.props.form433A.nonTaxpayer &&  this.props.form433A.nonTaxpayer.isSubmittedToIRS,
                isIrsApproved: this.props.form433A.nonTaxpayer &&  this.props.form433A.nonTaxpayer.isApproved,
                envelopeId: this.props.form433A.nonTaxpayer &&  this.props.form433A.nonTaxpayer.envelopeId,
                isEligibleToReSubmit: this.props.form433A.nonTaxpayer &&  this.props.form433A.nonTaxpayer.isEligibleToResubmit,
                isIrsRejected: this.props.form433A.nonTaxpayer &&  this.props.form433A.nonTaxpayer.isRejected
            },
            form433DStepper: {
                formCompleted: this.props.form433D.envelopeId ? true : false,
                docusignCompleted: this.props.form433D.isSignatureCompleted,
                submittedToIrs: this.props.form433D.isSubmittedToIRS,
                isIrsApproved: this.props.form433D.isApproved,
                envelopeId: this.props.form433D.envelopeId ? this.props.form433D.envelopeId : '',
                isEligibleToReSubmit: this.props.form433D.isEligibleToResubmit,
                isIrsRejected: this.props.form433D.isRejected
            },
            userDetail: this.props.rowDetail,
            isFrom8821Open: this.props.form8821.isEligibleToResubmit,
            isFrom433AOpen: this.props.form433A.isEligibleToResubmit,
            isFrom433DOpen: this.props.form433D.isEligibleToResubmit,
            isJointFrom8821Open: false,
            isJointFrom433AOpen: false

        }
    }

    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                ///... call initial load
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }

    private calculateActiveStep = (formStepper: IFormStepper) => {
        return Object.entries(formStepper)
            .filter(([key, value]) => key !== "envelopeId" && Boolean(value))
            .length;
    };

    private returnColorCode(formStepper: IFormStepper, index: number): boolean {

        return Object.values(formStepper)[index];
    }

    /**
    * Below function download the form-8821 of the user 
    * @param row - respective row details for which the download button is clicked
    */
    private async downloadForm8821(body: any, isTaxPayer = true) {

        try {
            // const body = {
            //     envelopeId: isTaxPayer ? this.state.formStepper.envelopeId : this.state.form8821.nonTaxpayer.envelopeId,
            //     isSubmittedtoIRS: isTaxPayer ? this.state.formStepper.submittedToIrs : this.state.form8821.nonTaxpayer.isSubmittedToIRS,
            //     formType: formType
            // };
            FormServices.downloadDocusignedPDF(body, this.state.accessToken).then((r) => {
                if (r.ok) {
                    r.json().then((response) => {

                        const byteCharacters = atob(response.body);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);

                        const blob = new Blob([byteArray], { type: response.headers['Content-Type'] });

                        const url = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = `${this.state.userDetail.email}_${body.formType}.pdf`;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);

                    });
                }
            });

        } catch (error: any) {
            console.error('Error downloading the file:', error.response?.data || error.message);
            ShowBlocker(false);

        }

    }

    private handleChange(form: string) {
        switch (form) {
            case 'form8821':
                this.setState({ isFrom8821Open: !this.state.isFrom8821Open });
                break;
            case 'form433A':
                this.setState({ isFrom433AOpen: !this.state.isFrom433AOpen });
                break;
            case 'form433D':
                this.setState({ isFrom433DOpen: !this.state.isFrom433DOpen });
                break;
            case 'jointForm8821':
                this.setState({ isJointFrom8821Open: !this.state.isJointFrom8821Open });
                break;
            case 'jointForm433A':
                this.setState({ isJointFrom433AOpen: !this.state.isJointFrom433AOpen });
                break;
        }
    }

    private checkActionReqCondition(stepper: IFormStepper) {
        try {

            return (stepper.docusignCompleted && (!stepper.submittedToIrs && !stepper.isIrsApproved && !stepper.isIrsRejected)) || stepper.isEligibleToReSubmit;
        }
        catch (ex) {

        }
    }

    public render() {
        const { formStepper } = this.state;
        const { form433AStepper } = this.state;
        const { form433DStepper } = this.state;
        const {jointFormStepper} = this.state;
        const {jointForm433AStepper} = this.state;
        const activeStep = this.calculateActiveStep(formStepper);
        const activeForm433AStep = this.calculateActiveStep(form433AStepper);
        const activeForm433DStep = this.calculateActiveStep(form433DStepper);
        console.log(activeStep, 'actv step')
        return (
            <div>
                <Accordion expanded={!this.state.isFrom8821Open} onChange={() => { this.handleChange('form8821') }}>
                    <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography component="span">Form 8821</Typography>
                        {this.checkActionReqCondition(this.state.formStepper) ? <Typography component="span" className='viewUser-typography'> Note: DocuSigned Form needs to be submitted to IRS</Typography> : ''}
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'center' }}>
                                <Stepper activeStep={activeStep} alternativeLabel >
                                    {steps.map((label, index) => {
                                        { console.log(Object.values(formStepper)[index], label, index) }
                                        { console.log(Object.values(formStepper)) }
                                        return (
                                            <Step key={label} completed={Object.values(formStepper)[index]} >
                                                <StepLabel slotProps={{
                                                    label: {
                                                        sx: {
                                                            color: this.returnColorCode(this.state.formStepper, index) ? 'var(--primary-main)  !important' : 'grey !important',
                                                        },
                                                    },
                                                }}>{label}</StepLabel>
                                            </Step>
                                        )
                                    })}
                                </Stepper>
                            </Box>
                            <div style={{ width: '70%', margin: '0 auto', textAlign: 'center' }}>
                                <button className='viewUser-Action-Btn' onClick={
                                    async () => {
                                        let body = {
                                            envelopeId:  this.state.formStepper.envelopeId ,
                                            isSubmittedtoIRS: this.state.formStepper.submittedToIrs ,
                                            formType: 'form-8821'
                                        };
                                        await this.downloadForm8821(body);
                                    }
                                }> Download Form-8821</button>
                                {/* <button className='viewUser-Action-Btn' onClick={
                                    async () => {
                                        console.log(this.state.userDetail);
                                        await this.pullTranscriptDetails(this.state.userDetail);
                                    }
                                }> View Transcript Details</button> */}

                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                {this.state.form8821.nonTaxpayer && <Accordion expanded={!this.state.isJointFrom8821Open} onChange={() => { this.handleChange('jointForm8821') }}>
                    <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography component="span">Spouse's Form 8821</Typography>
                        {this.checkActionReqCondition(this.state.jointFormStepper) ? <Typography component="span" className='viewUser-typography'> Note: DocuSigned Form needs to be submitted to IRS</Typography> : ''}
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'center' }}>
                                <Stepper activeStep={activeStep} alternativeLabel >
                                    {steps.map((label, index) => {
                                      
                                        return (
                                            <Step key={label} completed={Object.values(jointFormStepper)[index]} >
                                                <StepLabel slotProps={{
                                                    label: {
                                                        sx: {
                                                            color: this.returnColorCode(this.state.jointFormStepper, index) ? 'var(--primary-main)  !important' : 'grey !important',
                                                        },
                                                    },
                                                }}>{label}</StepLabel>
                                            </Step>
                                        )
                                    })}
                                </Stepper>
                            </Box>
                            <div style={{ width: '70%', margin: '0 auto', textAlign: 'center' }}>
                                <button className='viewUser-Action-Btn' onClick={
                                    async () => {
                                        let body = {
                                            envelopeId:  this.state.jointFormStepper.envelopeId ,
                                            isSubmittedtoIRS: this.state.jointFormStepper.submittedToIrs ,
                                            formType: 'form-8821'
                                        };
                                        await this.downloadForm8821(body);
                                    }
                                }> Download Form-8821</button>
                                {/* <button className='viewUser-Action-Btn' onClick={
                                    async () => {
                                        console.log(this.state.userDetail);
                                        await this.pullTranscriptDetails(this.state.userDetail);
                                    }
                                }> View Transcript Details</button> */}

                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>}
                <Accordion expanded={this.state.isFrom433AOpen} onChange={() => { this.handleChange('form433A') }}>
                    <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        <Typography component="span">Form 433A</Typography>
                        {this.checkActionReqCondition(this.state.form433AStepper) ? <Typography component="span" className='viewUser-typography'> Note: DocuSigned Form needs to be submitted to IRS</Typography> : ''}
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'center' }}>
                                <Stepper activeStep={activeForm433AStep} alternativeLabel >
                                    {steps.map((label, index) => (

                                        <Step key={label} completed={Object.values(form433AStepper)[index]} color='success'>
                                            <StepLabel slotProps={{
                                                label: {
                                                    sx: {
                                                        color: this.returnColorCode(this.state.form433AStepper, index) ? 'var(--primary-main) !important' : 'grey !important',
                                                    },
                                                },
                                            }}>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </Box>
                            <div style={{ width: '70%', margin: '0 auto', textAlign: 'center' }}>
                                <button className='viewUser-Action-Btn' onClick={
                                    async () => {
                                        let body = {
                                            envelopeId:  this.state.form433AStepper.envelopeId ,
                                            isSubmittedtoIRS: this.state.form433AStepper.submittedToIrs ,
                                            formType: 'form-433A'
                                        };
                                        await this.downloadForm8821(body);
                                    }
                                }> Download Form-433A</button>
                                {/* <button className='viewUser-Action-Btn' onClick={
                                    async () => {
                                        console.log(this.state.userDetail);
                                        await this.pullTranscriptDetails(this.state.userDetail);
                                    }
                                }> View Transcript Details</button> */}

                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                 {this.state.form433A.nonTaxpayer && <Accordion expanded={!this.state.isJointFrom8821Open} onChange={() => { this.handleChange('jointForm433A') }}>
                    <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography component="span">Spouse's Form 433A</Typography>
                        {this.checkActionReqCondition(this.state.jointForm433AStepper) ? <Typography component="span" className='viewUser-typography'> Note: DocuSigned Form needs to be submitted to IRS</Typography> : ''}
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'center' }}>
                                <Stepper activeStep={activeStep} alternativeLabel >
                                    {steps.map((label, index) => {
                                      
                                        return (
                                            <Step key={label} completed={Object.values(jointForm433AStepper)[index]} >
                                                <StepLabel slotProps={{
                                                    label: {
                                                        sx: {
                                                            color: this.returnColorCode(this.state.jointForm433AStepper, index) ? 'var(--primary-main) !important' : 'grey !important',
                                                        },
                                                    },
                                                }}>{label}</StepLabel>
                                            </Step>
                                        )
                                    })}
                                </Stepper>
                            </Box>
                            <div style={{ width: '70%', margin: '0 auto', textAlign: 'center' }}>
                                <button className='viewUser-Action-Btn' onClick={
                                    async () => {
                                        let body = {
                                            envelopeId:  this.state.jointForm433AStepper.envelopeId ,
                                            isSubmittedtoIRS: this.state.jointForm433AStepper.submittedToIrs ,
                                            formType: 'form-433A'
                                        };
                                        await this.downloadForm8821(body);
                                    }
                                }> Download Form-433A</button>
                                {/* <button className='viewUser-Action-Btn' onClick={
                                    async () => {
                                        console.log(this.state.userDetail);
                                        await this.pullTranscriptDetails(this.state.userDetail);
                                    }
                                }> View Transcript Details</button> */}

                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>}
                <Accordion expanded={this.state.isFrom433DOpen} onChange={() => { this.handleChange('form433D') }}>
                    <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <Typography component="span">Form 433D</Typography>
                        {this.checkActionReqCondition(this.state.form433DStepper) ? <Typography component="span" className='viewUser-typography'> Note: DocuSigned Form needs to be submitted to IRS</Typography> : ''}
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'center' }}>
                                <Stepper activeStep={activeForm433DStep} alternativeLabel >
                                    {steps.map((label, index) => (

                                        <Step key={label} completed={Object.values(activeForm433DStep)[index]} color='success'>
                                            <StepLabel slotProps={{
                                                label: {
                                                    sx: {
                                                        color: this.returnColorCode(this.state.form433DStepper, index) ? 'var(--primary-main)  !important' : 'grey !important',
                                                    },
                                                },
                                            }}>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </Box>
                            <div style={{ width: '70%', margin: '0 auto', textAlign: 'center' }}>
                                <button className='viewUser-Action-Btn' onClick={
                                    async () => {
                                       let body = {
                                            envelopeId:  this.state.form433DStepper.envelopeId ,
                                            isSubmittedtoIRS: this.state.form433DStepper.submittedToIrs ,
                                            formType: 'form-433D'
                                        };
                                        await this.downloadForm8821(body);
                                    }
                                }> Download Form-433D</button>
                                {/* <button className='viewUser-Action-Btn' onClick={
                                    async () => {
                                        console.log(this.state.userDetail);
                                        await this.pullTranscriptDetails(this.state.userDetail);
                                    }
                                }> View Transcript Details</button> */}

                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </div>
        );
    }

}

export default ViewUser;